<template lang="html">
  <div>
    <div class="row">
      <div class="col-xs-2">
        <pl-input
          style="width: 100%"
          v-model="course_search"
          placeholder="Search Courses"
          @keyup.enter="filters"
        />
      </div>
      <div
        v-if="coursesFilters && coursesFilters.teachers_emails"
        class="col-xs-2"
      >
        <multiselect
          v-model="selected_teacher"
          :options="coursesFilters.teachers_emails"
          :close-on-select="true"
          :preserve-search="true"
          placeholder="Teachers"
          label="name"
          track-by="name"
          @input="filters"
          style="max-width: 100%"
        />
      </div>
      <div v-if="coursesFilters && coursesFilters.subjects" class="col-xs-2">
        <multiselect
          v-model="selected_subject"
          :options="coursesFilters.subjects"
          :close-on-select="true"
          :preserve-search="true"
          placeholder="Subjects"
          label="name"
          track-by="name"
          @input="filters"
          style="max-width: 100%"
        />
      </div>
      <div
        v-if="coursesFilters && coursesFilters.school_sites"
        class="col-xs-2"
      >
        <multiselect
          v-model="selected_school_site"
          :options="coursesFilters.school_sites"
          :close-on-select="true"
          :preserve-search="true"
          placeholder="All Sites"
          label="name"
          track-by="name"
          @input="filters"
          style="max-width: 100%"
        />
      </div>
      <div v-if="coursesFilters && coursesFilters.grades" class="col-xs-2">
        <multiselect
          v-model="selected_grades"
          :options="coursesFilters.grades"
          :close-on-select="true"
          :preserve-search="true"
          placeholder="All Grades"
          label="name"
          track-by="name"
          @input="filters"
          style="max-width: 100%"
        />
      </div>
      <div class="col-xs-2">
        <pl-select
          :options="is_connected"
          :selected="selected_connectedType"
          :arrow="true"
          placeholder="Existing / Nonexisting"
          @change="filterCoursesByConnection($event)"
          style="color: #adadad"
        >
        </pl-select>
      </div>
    </div>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect';
  export default {
    components: {
      Multiselect,
    },
    data() {
      return {
        course_search: '',
        selected_teacher: [],
        selected_subject: [],
        selected_school_site: [],
        selected_grades: [],
        is_connected: ['Existing', 'Nonexisting'],
        selected_connectedType: 'Existing / Nonexisting',
        is_connected_aux: undefined,
      };
    },
    props: {
      coursesFilters: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    methods: {
      filters() {
        const filters = {
          course_title: this.course_search,
          teacher_email:
            this.selected_teacher && this.selected_teacher.name
              ? this.selected_teacher.name
              : '',
          subject:
            this.selected_subject && this.selected_subject.name
              ? this.selected_subject.name
              : '',
          school_site:
            this.selected_school_site && this.selected_school_site.name
              ? this.selected_school_site.name
              : '',
          grade:
            this.selected_grades && this.selected_grades.name
              ? this.selected_grades.name
              : '',
          is_connected:
            this.is_connected_aux !== undefined ? this.is_connected_aux : '',
        };

        this.$emit('admin-portal-filter-changed');
        this.$emit('filters', filters);
      },
      filterCoursesByConnection(event) {
        this.selected_connectedType = event.toLowerCase();

        if (this.selected_connectedType === 'existing') {
          this.is_connected_aux = true;
        } else if (this.selected_connectedType === 'nonexisting') {
          this.is_connected_aux = false;
        }

        const filters = {
          course_title: this.course_search,
          teacher_email:
            this.selected_teacher && this.selected_teacher.name
              ? this.selected_teacher.name
              : '',
          subject:
            this.selected_subject && this.selected_subject.name
              ? this.selected_subject.name
              : '',
          school_site:
            this.selected_school_site && this.selected_school_site.name
              ? this.selected_school_site.name
              : '',
          grade:
            this.selected_grades && this.selected_grades.name
              ? this.selected_grades.name
              : '',
          is_connected:
            this.is_connected_aux !== undefined ? this.is_connected_aux : '',
        };

        this.$emit('admin-portal-filter-changed');
        this.$emit('filters', filters);
      },
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~app/global-stylus.styl';

  .custom-select
    height: 40px
    padding 0px !important
    border: 2px solid #e1e8ee
    border-top-left-radius: 10px
    border-top-right-radius: 10px
    border-bottom-left-radius: 10px
    border-bottom-right-radius: 10px
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
  .multiselect {
    .multiselect__content-wrapper {
      max-width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// adminPortalIntegrationsFiltersBar.vue?e998bbc4